// import Vue from 'vue'
import axiosInit from 'axios'
import config from '../config/index'
import store from '../store/index'
import router from '../router'
import { Message } from 'element-ui'
// Vue.use(Message)
axiosInit.defaults.baseURL = config.api_url
/**
 * 所有ajax的请求前的处理
 */
axiosInit.interceptors.request.use((config) => {
  // 获取到token
  let token = store.state.Auth.token
  if (token) {
    if (config.params) {
      config.params.token = token
    } else {
      if (config.method === 'get' || config.method === 'delete') {
        config.params = {}
        config.params.token = token
      } else {
        if (config.data) {
          config.data.token = token
        } else {
          config.data = {}
          config.data.token = token
        }
      }
    }
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

/**
 * 所有ajax的请求返回值的处理
 */
axiosInit.interceptors.response.use((rsp) => {
  // 在这里对返回的数据进行处理
  switch (rsp.data.resultCode) {
    case -1:
      Message.error('登录已失效，请重新登录！')
      setTimeout(function () {
        // 清空登录信息
        store.dispatch('logout').then(() => {
          router.push({ name: 'Login', query: {referer: window.location.href} })
        })
      }, 0)
      break
  }
  return rsp
}, (error) => {
  switch (error.response.status) {
    case 401:
      Message.error('登录已失效，请重新登录！')
      setTimeout(function () {
        // 清空登录信息
        // 清空登录信息
        store.dispatch('logout').then(() => {
          router.push({ name: 'Login', query: {referer: window.location.href} })
        })
      }, 0)
      break
    case 404:
      break
    case 500:
      Message(error.response.data.message)
      break
    case 400:
      Message.error('登录已失效，请重新登录！')
      setTimeout(function () {
        // 清空登录信息
        store.dispatch('logout').then(() => {
          router.push({ name: 'Login', query: {referer: window.location.href} })
        })
      }, 0)
      // if (error.response.data.resultCode === -1) {
      //   Message.error('登录已失效，请重新登录！')
      //   setTimeout(function () {
      //     // 清空登录信息
      //     store.dispatch('logout').then(() => {
      //       router.push({ name: 'Login', query: {referer: window.location.href} })
      //     })
      //   }, 2000)
      // } else {
      //   Message(error.response.data.message)
      // }
      break
    case 503:
      Message.error('服务器错误，请重新尝试操作！')
      break
  }
  return Promise.reject(error)
})

export default axiosInit



// WEBPACK FOOTER //
// ./src/global/axios.js